import { render, staticRenderFns } from "./AdditionalAccount.vue?vue&type=template&id=2a99877e&scoped=true&"
import script from "./AdditionalAccount.vue?vue&type=script&lang=js&"
export * from "./AdditionalAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99877e",
  null
  
)

export default component.exports